module.exports = __webpack_public_path__ + "84a0e4e45cc2dba08b6cf947e9f79b91.png";